/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：154
 */

import { d } from "./index__part-0"
import "./index__part-1"
import * as /* [auto-meaningful-name] */Module_798 from /* 798 */"../../709/798/index"
import * as /* [auto-meaningful-name] */Module_19 from /* 19 */"../../../../19"
var _a
_a = function (e, t) {
  return d(e, Module_19.a({
    defaultTheme: Module_798.a
  }, t))
}
export { _a as a }
export default _a
